'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ImageUploaderDirective = function () {
  function ImageUploaderDirective() {
    var _this = this;

    _classCallCheck(this, ImageUploaderDirective);

    this.link = function (scope, element, attrs) {
      var fileInput = element[0].querySelector('.image-file-input');

      scope.select = function () {
        return fileInput.click();
      };

      element.on('change', function (e) {
        return _this.selected(e, fileInput, scope);
      });
      element.on('$destroy', function () {
        return element.off();
      });
    };

    this.restrict = 'E';
    this.scope = {
      disabled: '=',
      fileSelected: '&'
    };
    this.template = require('./tpl.html');
  }

  _createClass(ImageUploaderDirective, [{
    key: 'selected',
    value: function selected(e, fileInput, scope) {
      if (!fileInput.files || !fileInput.files.length) {
        return;
      }
      scope.fileSelected({ files: fileInput.files });
    }
  }]);

  return ImageUploaderDirective;
}();

exports.ImageUploaderDirective = ImageUploaderDirective;


//////////////////
// WEBPACK FOOTER
// ./product-list/image-uploader/index.js
// module id = 496
// module chunks = 0